import React, { useContext, useEffect, useState } from "react";
import { Context } from "../../state/context";

import './tags-left-panel.styles.scss';
import useFetch from "../../api/fetch";

import Tag from "../tag/tag.component";



export default function TagsLeftPanel() {
    const initialDnDState = {
        draggedFrom: null,
        draggedTo: null,
        isDragging: false,
        originalOrder: [],
        updatedOrder: []
    };

    const { state, dispatch } = useContext(Context);
    const fetch = useFetch();
    const [tags, setTags] = useState([]);
    const [filteredTags, setFilteredTags] = useState([]);
    const [search, setSearch] = useState("");
    const [showSave, setShowSave] = useState(false);
    const [showMarketing, setShowMarketing] = useState(false);
    const [dragAndDrop, setDragAndDrop] = useState( initialDnDState );

    const onDragStart = (e) => {
        const initialPosition = Number(e.currentTarget.dataset.position);

        setDragAndDrop({
            ...dragAndDrop,
            draggedFrom: initialPosition, // set the draggedFrom position
            isDragging: true,
            originalOrder: tags // store the current state of "tags"
        });

        // Note: this is only for Firefox.
        // Without it, the DnD won't work.
        // But we are not using it.
        e.dataTransfer.setData("text/html", '');
    };

    const onDragOver = (e) => {
        e.preventDefault();
        let newList = dragAndDrop.originalOrder;

        const draggedFrom = dragAndDrop.draggedFrom;
        const draggedTo = Number(e.currentTarget.dataset.position);
        const itemDragged = newList[draggedFrom];
        const remainingItems = newList.filter((item, index) => index !== draggedFrom);

        newList = [
            ...remainingItems.slice(0, draggedTo),
            itemDragged,
            ...remainingItems.slice(draggedTo)
        ];

        if (draggedTo !== dragAndDrop.draggedTo){
            setDragAndDrop({
                ...dragAndDrop,
                updatedOrder: newList,
                draggedTo: draggedTo
            })
        }
    }

    const onDrop = (e) => {
        setShowSave(state.tags !== dragAndDrop.updatedOrder);
        setTags(dragAndDrop.updatedOrder);
        setDragAndDrop({
            ...dragAndDrop,
            draggedFrom: null,
            draggedTo: null,
            isDragging: false
        });
    }

    useEffect(() => {
        setFilteredTags(state.tags);
        setTags(state.tags);
        dispatch({type: 'SET_ACTIVE_TAG', activeTag: state.tags[0]});
    }, [state.tags]);

    useEffect(() => {
        if (filteredTags.length > 0) {
            dispatch({type: 'SET_ACTIVE_TAG', activeTag: filteredTags[0]});
        }
    }, [filteredTags]);

    useEffect(() => {
        var filtered = tags.filter(({ name }) => name.toLowerCase().includes(search.toLowerCase()));

        if(showMarketing) {
            filtered = filtered.filter(({is_marketing}) => is_marketing > 0);
        }
        console.log(filtered);

        setFilteredTags(filtered);
    }, [search, showMarketing]);

    const handleSaveOrder = async () => {
        const formData = new FormData();
        const orderArray = {};
        tags.forEach((tag, index) => orderArray[tag.id] = index+1);

        formData.append('newOrder', JSON.stringify(orderArray));

        const result = await fetch("/api/tags/order-tags", {
            method: "POST",
            body: formData
        }).then(res => res.json());

        if(result.success) {
            setShowSave(false);
            dispatch({type: 'SET_TAGS', tags: tags});
        } else {
            setTags(state.tags);
        }
    }

    return (
        <div className="d-flex flex-column col-6">
            <div className="d-flex align-items-center justify-content-between mb-3">
                <h6>Tags list</h6>
                {showSave && <button className="btn btn-mondly btn-blue" onClick={handleSaveOrder}>Save order</button>}
            </div>
            <div className="d-flex align-items-center justify-content-between mb-3 row">
                <div className="input-group search-field col-9">
                    <input className={"form-control shadow-none border-right-0"}
                        placeholder={"Search"}
                        value={search}
                        onChange={(e) => setSearch(e.target.value)} />
                    <div className="input-group-append">
                        <span className={"input-group-text bg-transparent border-left-0"}><i className="fas fa-search"></i></span>
                    </div>
                </div>
                <div className="custom-control custom-checkbox col-3 d-flex justify-content-end">
                    <input type="checkbox" className="custom-control-input" id="onlyMarketing" onChange={(e) => setShowMarketing(e.target.checked)}/>
                    <label className="custom-control-label" htmlFor="onlyMarketing">Show only marketing</label>
                </div>
            </div>
            <div className="tags-column">
                {filteredTags.map((tag, index) => (
                    <Tag data-position={index}
                        draggable="true"
                        onDragStart={onDragStart}
                        onDragOver={onDragOver}
                        onDrop={onDrop}
                        key={tag.id}
                        tag={tag} />
                        
                ))}
            </div>

        </div>
    )
}